import React from 'react';
import ProgressBar from "@ramonak/react-progress-bar";
// Progress Bar component
const ProgressBarComponent = ({ progress, className }) => {

  // Style for the progress bar container
  const containerStyles = {
    width: '80%',
    position: 'absolute',
  };

  return (
    
    <div className={className} style={containerStyles}>
      <ProgressBar 
        transitionDuration={'3s'} 
        completed={parseInt(progress)} 
        bgColor='var(--primary-color)'
      />
    </div>
  );
};

export default ProgressBarComponent;
